import getEventTargetValue from '../../../utils/get-event-target-value';
import { changeQuoteLine, changeQuoteLineGender } from '../../actions';
import { connectEditor } from '../../connect-editor';
import QuoteLineGenderDetails from './QuoteLineGenderDetails';

const mapStateToProps = ({ quoteLinesById, productsById }, { quoteLineId }) => {
  const quoteLine = quoteLinesById[quoteLineId];
  const product = productsById[quoteLine.productId];
  return {
    genders: quoteLine.genders,
    genderShares: {
      genderMenShare: quoteLine.genderMenShare,
      genderKidsShare: quoteLine.genderKidsShare,
      genderWomenShare: quoteLine.genderWomenShare,
    },
    product,
  };
};

const mapDispatchToProps = {
  changeQuoteLineGender,
  changeQuoteLine,
};

const mergeProps = ({ product, ...stateProps }, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onShareChange: event =>
    dispatchProps.changeQuoteLine(
      event.target.dataset.quoteLineId,
      event.target.name,
      getEventTargetValue(event.target),
      event.target.dataset.derived,
    ),
  onGenderChange: event =>
    dispatchProps.changeQuoteLineGender(
      event.target.dataset.quoteLineId,
      getEventTargetValue(event.target),
      product,
    ),
});

export default connectEditor(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(QuoteLineGenderDetails);
